<template>
  <Transition name="fade">
    <div
      v-if="errorStore.errorMessage"
      class="global-error"
    >
      <div class="global-error__content">
        <p class="global-error__message">{{ errorStore.errorMessage }}</p>
        <button
          class="global-error__close"
          @click="errorStore.clearError()"
          :aria-label="$t('components.error.close')"
        >
          <svg class="global-error__close-icon">
            <use :xlink:href="`#${cancel}`" />
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useErrorStore } from '@/stores/errorStore'
  import cancel from '@/assets/icons/cancel.svg'

  export default defineComponent({
    name: 'GlobalError',
    setup() {
      const errorStore = useErrorStore()

      return {
        errorStore,
        cancel,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .global-error {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: $clr-error;
    color: $clr-white;
    padding: 1rem;

    &__content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }

    &__message {
      margin: 0;
      flex: 1;
    }

    &__close {
      background: none;
      border: none;
      padding: 0.5rem;
      cursor: pointer;
      color: $clr-white;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        opacity: 0.8;
      }

      &:focus {
        outline: 2px solid $clr-white;
        outline-offset: 2px;
      }
    }

    &__close-icon {
      width: 1rem;
      height: 1rem;
      fill: currentColor;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    transform: translateY(-100%);
    opacity: 0;
  }
</style>
